export const getShowPatientSection = (): boolean => process.env.REACT_APP_SHOW_PATIENT_SECTION === 'true';
